export const homeData = {
  hero: {
    trustBadge:
      "Trusted by DRDO · Indian Navy · ISRO · Etihad Airways · IndiGo",
    headingText:
      "Training isn't the problem.\nNot knowing whether it worked is.",
    subBadge: "AI-Powered Training Intelligence",
    description:
      "AEPL builds AI-powered training intelligence for aviation, defence, and energy the three industries where a single competency gap is measured in lives, missions, and regulatory consequences.",
    primaryCTA: "Request a Walkthrough",
    secondaryCTA: "See what we've built",
    microcopy:
      "30 minutes. A domain specialist. Your specific operational environment.",
  },
  stats: [
    {
      value: "SevenStar+",
      icon: "★",
      label: "Safety rating achieved for the airline we serve",
    },
    {
      value: "World's 3rd Largest LCC",
      icon: "★",
      label: "Fastest-ever CBTA implementation on record",
    },
    {
      value: "Active with MoD",
      icon: "★",
      label: "AI-based cognitive measurement for defence personnel",
    },
    {
      value: "DRDO · Navy · ISRO",
      icon: "★",
      label: "India's premier defence and space institutions",
    },
  ],
  problemWesolve: {
    heading: "The industries that cannot afford to guess are still guessing.",
    description:
      "In aviation, a training record that cannot be queried in real time is a compliance liability. In defence, readiness declared from a spreadsheet is readiness that does not exist. In energy, one operator qualified on paper  but not in practice  is a regulatory exposure waiting for a trigger event.",
    conclusion:
      "The training happened. The question no one can answer fast enough is: Did it produce competency?",
    callToAction:
      "That is the question AEPL was built to answer. Systematically. Verifiably. Before the regulator asks it for you.",
  },
  products: {
    heading:
      "Five precision instruments. One integrated training intelligence layer.",
    items: [
      {
        id: "raptor",
        title: "RAPTOR",
        tag: "1.Training Management System",
        description:
          "The operational backbone. Manages the complete training lifecycle  scheduling, compliance, qualification records, and regulatory audit trail  across aviation, defence, and energy from a single platform.",
        cta: "Explore RAPTOR",
        image1: "/HomePage/FivePrecisionInstruments/raptor1.webp",
        image2: "/HomePage/FivePrecisionInstruments/raptor2.webp",
      },
      {
        id: "learnon",
        title: "LearnOn",
        tag: "2.Adaptive Learning Engine",
        description:
          "Not every learner needs the same path. LearnOn analyses individual performance in real time and adjusts learning sequences, assessment difficulty, and remediation depth  compressing time-to-competency without reducing the standard.",
        cta: "Explore LearnOn",
        image1: "/HomePage/FivePrecisionInstruments/learnon1.webp",
        image2: "/HomePage/FivePrecisionInstruments/learnon2.webp",
      },
      {
        id: "aurora",
        title: "Aurora",
        tag: "3.Training Intelligence & Analytics",
        description:
          "Aurora converts raw training data into forward-looking operational intelligence  forecasting competency gaps, measuring training effectiveness, and giving leaders a live picture of workforce readiness before it becomes a problem.",
        cta: "Explore Aurora",
        image1: "/HomePage/FivePrecisionInstruments/aurora1.webp",
        image2: "/HomePage/FivePrecisionInstruments/aurora2.webp",
      },
      {
        id: "griffin",
        title: "GRIFFIN XR",
        tag: "4.Immersive Extended Reality Training",
        description:
          "When the scenario cannot be replicated safely in the real world, GRIFFIN XR builds it in extended reality. Biometric assessment, AI-driven feedback, and full RAPTOR integration  every session becomes a competency data point.",
        cta: "Explore GRIFFIN XR",
        image1: "/HomePage/FivePrecisionInstruments/griffin1.webp",
        image2: "/HomePage/FivePrecisionInstruments/griffin2.webp",
      },
      {
        id: "courseai",
        title: "CourseAI",
        tag: "5.AI-Native Content Intelligence",
        description:
          "xAPI-native. Pedagogically structured. AI-ready from day one. CourseAI builds, manages, and continuously improves course content aligned to competency frameworks  so your training library evolves as fast as your operational environment.",
        cta: "Explore CourseAI",
        image1: "/HomePage/FivePrecisionInstruments/courseai1.webp",
        image2: "/HomePage/FivePrecisionInstruments/courseai2.webp",
      },
    ],
  },
  industriesWeServe: {
    heading: "Industries We Serve",
    description:
      "Built for the three industries where the stakes remove the margin for error.",
    items: [
      {
        icon: "Plane",
        title: "Aviation",
        description:
          "We serve the world's safest airline. From Evidence-Based Training automation to fastest-ever CBTA implementation at a major low-cost carrier  AEPL's aviation platform performs where the regulatory pressure is highest.",
        color: "#00b4d8",
        image: "/PlatformImages/Industries/Aviation.webp",
        cta: "Aviation solutions",
        path: "/industries/aviation",
      },
      {
        icon: "Shield",
        title: "Defence",
        description:
          "Active collaboration with India's Ministry of Defence. AI-based cognitive measurement for defence personnel. GRIFFIN XR readiness training. Deployed across Air Force, Navy, Army, and Special Operations contexts.",
        color: "#10b981",
        image: "/PlatformImages/Industries/Defence.webp",
        cta: "Defence solutions",
        path: "/industries/defence",
      },
      {
        icon: "Zap",
        title: "Energy",
        description:
          "When one operator error shuts down a platform, competency is not a training goal  it is an operating licence condition. RAPTOR manages OPITO, GWO, NERC CIP, and WANO compliance for energy workforces where every qualification expiry is a liability.",
        color: "#f59e0b",
        image: "/PlatformImages/Industries/Energy.webp",
        cta: "Energy solutions",
        path: "/industries/energy",
      },
    ],
  },
  closingCTA: {
    heading: "Your workforce is training. Do you know if it's working?",
    description:
      "AEPL's Scoped Walkthrough is not a product demonstration. It is a 30-minute structured session with a domain specialist who has operated in your regulatory environment. You will leave with a specific deployment pathway, not a brochure.",
    primaryCTA: "Request a Scoped Walkthrough",
    secondaryCTA: "Download the Platform Overview",
    microcopy:
      "No commitment. No generic demos. Your sector, your standards, your questions.",
  },
  clients: {
    title: "Trusted by",
    list: [
      { name: "Etihad Airways", logo: "/clients/Etihad.svg" },
      { name: "IndiGo", logo: "/clients/Indigo.svg" },
      { name: "Indian Navy", logo: "/clients/IndianNavy.svg" },
      { name: "ALSTOM", logo: "/clients/Alstom.svg" },
      { name: "CAE", logo: "/clients/CAE.svg" },
      { name: "Delhi Metro", logo: "/clients/Delhimetro.svg" },
      { name: "Pune Metro", logo: "/clients/Punemetro.svg" },
      { name: "ONGC", logo: "/clients/Ongc.svg" },
      { name: "Marigold", logo: "/clients/Marigold.svg" },
      { name: "Sterling", logo: "/clients/Sterling.svg" },
    ],
  },
  compliance: {
    title: "Compliant with",
    standards: [
      "EASA",
      "ICAO",
      "DGCA",
      "GCAA",
      "OPITO",
      "GWO",
      "NERC CIP",
      "WANO",
      "MIL-STD",
    ],
  },
};
